import { Card, Col, Flex, Row, Statistic, Typography } from "antd";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import {
  ExclamationCircleOutlined,
  FallOutlined,
  RiseOutlined,
  ThunderboltFilled,
  InfoCircleOutlined,
} from "@ant-design/icons";
import CountUp from "react-countup";

const { Text, Title } = Typography;

const Rise = () => (
  <RiseOutlined style={{ color: "var(--ant-color-error)", marginRight: 6 }} />
);

const Drop = () => (
  <FallOutlined style={{ color: "var(--ant-color-success)", marginRight: 6 }} />
);

const valueFormatter = (value) => {
  return value
    ? value >= 1000000
      ? value / 1000.0
      : value
    : value === 0
    ? value
    : null;
};

function MaxDemandHighlightCard({
  currentValue = 0,
  currentValueDateTime,
  lastValue = 0,
}) {
  const numberFormat = { maximumFractionDigits: 1, minimumFractionDigits: 1 };

  return (
    <Card
      size="small"
      bordered
      styles={{
        body: {
          position: "relative",
        },
      }}
    >
      {/* <Text
        style={{
          position: "absolute",
          right: 24,
          top: 18,
          fontSize: 36,
          color: "var(--ant-volcano)",
          lineHeight: 1,
        }}
        italic
        strong
      >
        kW
      </Text> */}
      <Row gutter={[12, 12]}>
        <Col span={24}>
          <Flex justify="start" align="end" gap={8}>
            <Statistic
              title={
                <Title level={5} style={{ margin: 0, marginBottom: 8 }}>
                  Maximum Demand
                </Title>
              }
              valueStyle={{
                fontSize: "var(--ant-font-size-heading-2)",
                fontWeight: "var(--ant-font-weight-strong)",
              }}
              value={valueFormatter(currentValue)}
              precision={2}
              formatter={(value) => (
                <CountUp
                  end={value}
                  separator=","
                  duration={1.5}
                  decimals={2}
                />
              )}
              suffix={
                <Title level={2} style={{ margin: 0 }} italic>
                  {currentValue >= 1000000
                    ? "MW"
                    : currentValue === "N/A"
                    ? ""
                    : "kW"}
                </Title>
              }
            ></Statistic>
          </Flex>
          <Flex justify="start" align="center" gap={4}>
            {currentValue > lastValue ? <Rise /> : <Drop />}
            <Text>
              {valueFormatter(lastValue)?.toLocaleString("en-US", numberFormat)}{" "}
              {lastValue >= 1000000 ? "MW" : lastValue === "N/A" ? "" : "kW"}
            </Text>
            <Text type="secondary">Last Month (To-Date)</Text>
          </Flex>
        </Col>
      </Row>
    </Card>
    // <Card
    //   title={
    //     <Flex justify="space-between">
    //       <Title level={5} style={{ margin: 0, marginRight: 8 }}>
    //         <RiseOutlined style={{ marginRight: 12 }} />
    //         Maximum Demand
    //       </Title>
    //       {currentValueDateTime?.length > 0 && (
    //         <InfoCircleOutlined
    //           title={
    //             currentValueDateTime.length === 1
    //               ? "The maximum demand occured on " +
    //                 currentValueDateTime[0]["StartDateTime"]
    //               : "The maximum demand occured on " +
    //                 currentValueDateTime
    //                   .map((item) => item["StartDateTime"])
    //                   .join(" and ")
    //           }
    //         />
    //       )}
    //     </Flex>
    //   }
    //   size="small"
    //   bordered
    // >
    //   <Row gutter={[12, 12]}>
    //     <Col span={24}>
    //       <Flex justify="start" align="end" gap={8}>
    //         <Title level={2} style={{ margin: 0 }}>
    //           {currentValue
    //             ? currentValue >= 1000000
    //               ? (currentValue / 1000.0).toLocaleString(
    //                   "en-US",
    //                   numberFormat
    //                 )
    //               : currentValue.toLocaleString("en-US", numberFormat)
    //             : currentValue === 0
    //             ? currentValue
    //             : " - "}
    //         </Title>
    //         <Title level={2} style={{ margin: 0 }} italic>
    //           {currentValue >= 1000000
    //             ? "MW"
    //             : currentValue === "N/A"
    //             ? ""
    //             : "kW"}
    //         </Title>
    //       </Flex>
    //     </Col>
    //     {/* <Col span={24}>
    //                 <Flex justify='end' align='center' gap={8}>
    //                     <Title level={4} style={{ margin: 0 }} type={lastValue > currentValue ? 'success' : 'danger'}> {lastValue > currentValue ? <FallOutlined /> : <RiseOutlined />}
    //                     </Title>
    //                     <Text italic>Last :
    //                         {
    //                             lastValue?
    //                                 lastValue >= 1000000 ?
    //                                 (lastValue / 1000.0).toLocaleString('en-US', numberFormat)
    //                                 :
    //                                 lastValue.toLocaleString('en-US', numberFormat)
    //                             :
    //                             ' - '
    //                         }
    //                         <Text italic>{lastValue >= 1000000 ? 'MW ': 'kW '}</Text>
    //                         ( {
    //                             currentValue? lastValue? ((currentValue - lastValue) / lastValue).toLocaleString('en-US', { maximumFractionDigits: 1, style: 'percent' }) : ' - %' : ' - %'
    //                         } )
    //                     </Text>
    //                 </Flex>
    //             </Col> */}
    //   </Row>
    // </Card>
  );
}

export default MaxDemandHighlightCard;
